
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import CompsFilter from './comps_filters';
export class CompsFiltersContainer extends React.Component {
  static propTypes = {
    addressFilter: PropTypes.object.isRequired,
    marketTypeOptions: PropTypes.array.isRequired,
    propertyFilter: PropTypes.object.isRequired,
    selectedAssetClasses: PropTypes.array.isRequired,
    selectedBuildingClasses: PropTypes.array.isRequired,
    selectedInvestmentTypes: PropTypes.array.isRequired
  }


  render() {
    return (
      <CompsFilter {...this.props}/>
    );
  }
}

const mapStateToProps = state => ({
  addressFilter: state.query.addressFilter,
  marketTypeOptions: state.static.marketTypeOptions,
  propertyFilter: state.query.propertyFilter,
  selectedBuildingClasses: state.query.buildingClasses,
  selectedAssetClasses: state.query.assetClasses,
  selectedInvestmentTypes: state.query.investmentTypes
});

export default connect(mapStateToProps)(CompsFiltersContainer);
